import React, { useState } from 'react';

import { HelpPanel, Modal } from '@copilot/ui';
import Icon from '../common/Icon';
import { ALL_HELP_SECTIONS } from '../../constants/helpContent';

function browserDetails() {
  const ua = window.navigator.userAgent || '';
  const patterns = [
    ['Edge', /Edg\/([\d.]+)/],
    ['Chrome', /Chrome\/([\d.]+)/],
    ['Firefox', /Firefox\/([\d.]+)/],
    ['Safari', /Version\/([\d.]+).*Safari/],
  ];
  const match = patterns.find(([, pattern]) => pattern.test(ua));
  return match ? `${match[0]} ${ua.match(match[1])?.[1] ?? ''}`.trim() : 'Unknown browser';
}

function operatingSystem() {
  const ua = window.navigator.userAgent || '';
  if (/Windows/i.test(ua)) return 'Windows';
  if (/Android/i.test(ua)) return 'Android';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS/iPadOS';
  if (/Macintosh|Mac OS X/i.test(ua)) return 'macOS';
  if (/Linux/i.test(ua)) return 'Linux';
  return 'Unknown';
}

function currentFeature() {
  const path = window.location.pathname;
  if (path.includes('/billing')) return 'Plan & Billing';
  if (path.includes('/documents')) return 'Documents';
  if (path.includes('/settings')) return 'Settings';
  if (path.includes('/analytics')) return 'Analytics';
  if (path.includes('/ask')) return 'Ask KrishvaQ';
  if (path.includes('/meetings')) return 'Meetings';
  return 'Web application';
}

function supportMailto(email) {
  const subject = 'KrishvaQ Support Request';
  const body = [
    'Hello KrishvaQ Support,',
    '',
    'I need help with:',
    '[Describe the issue]',
    '',
    'Platform: Web',
    `KrishvaQ version: ${process.env.REACT_APP_VERSION || 'Not provided by this build'}`,
    `Browser: ${browserDetails()}`,
    `Operating system: ${operatingSystem()}`,
    `Current feature: ${currentFeature()}`,
    '',
    'Issue area:',
    '',
    'Steps to reproduce:',
    '1.',
    '2.',
    '3.',
    '',
    'Expected result:',
    '',
    'Actual result:',
  ].join('\n');

  return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function HelpModal({ onClose }) {
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL;
  const [contactError, setContactError] = useState(false);
  const [copyStatus, setCopyStatus] = useState('');

  const handleContactSupport = supportEmail
    ? () => {
        setContactError(false);
        try {
          const opened = window.open(supportMailto(supportEmail), '_self');
          if (opened === null) setContactError(true);
        } catch {
          setContactError(true);
        }
      }
    : undefined;

  const copySupportEmail = async () => {
    try {
      await window.navigator.clipboard.writeText(supportEmail);
      setCopyStatus('Support email copied.');
    } catch {
      setCopyStatus(`Support email: ${supportEmail}`);
    }
  };

  return (
    <Modal title="Help & Support" subtitle="How can we help?" size="md" onClose={onClose}>
      <HelpPanel
        sections={ALL_HELP_SECTIONS}
        searchIcon={<Icon name="search" size={16} className="help-search-icon" />}
        chevronIcon={<Icon name="chevron-down" size={16} />}
        contactIcon={<Icon name="phone" size={15} />}
        onContactSupport={handleContactSupport}
      />
      {contactError && supportEmail && (
        <div className="help-contact" role="status">
          <p className="help-contact-fallback">Could not open your email application.</p>
          <button type="button" className="btn btn-secondary" onClick={copySupportEmail}>
            Copy support email
          </button>
          {copyStatus && <p>{copyStatus}</p>}
        </div>
      )}
    </Modal>
  );
}

export default HelpModal;
